{
  "page": {
    "title": "Einrichtung",
    "get_started": {
      "greeting": "Willkommen!",
      "info": "Vielen Dank, dass Sie sich für Scalefield entschieden haben.\nIn diesem Schnelleinrichtungsassistenten führen wir Sie durch die wichtigsten Schritte, damit Sie mit der Erstellung Ihrer Cluster beginnen können."
    },
    "superuser": {
      "title": "Administratorkonto",
      "description": "Das Scalefield-Administratorenkonto gewährt volle Kontrolle über die Scalefield-Instanz, einschließlich der Erstellung von Organisationen, der Konfiguration von Einstellungen und der Sicherheit."
    },
    "organization": {
      "title": "Organisation",
      "description": "Eine Organisation in Scalefield ist Ihr zentraler Hub zur Verwaltung von Projekten, Services und Teams. Sie vereinfacht das Ressourcenmanagement, die Zugriffskontrolle und die Zusammenarbeit und sorgt für effizientes Teamwork.",
      "fields": {
        "organization_name": "Organisationsname",
        "address_line_1": "Straße"
      }
    },
    "email_configuration": {
      "title": "E-Mail Einstellungen",
      "description": "Die E-Mail Einstellungen in Scalefield ist entscheidend, um der Plattform das Versenden von Benachrichtigungen an Benutzer zu ermöglichen.",
      "test_email_info": "Eine E-Mail wird an die Adresse Ihres Administratorkontos gesendet"
    },
    "buttons": {
      "get_started": "Loslegen",
      "skip": "Überspringen",
      "submit": "Weiter",
      "test_email": "Test-E-Mail senden"
    }
  }
}
